module.exports = __webpack_public_path__ + "img/stock3.c7f22035.png";